<template>
  <vs-col vs-lg="6" vs-sm="12" vs-xs="12" class="mb-8">
    <div v-if="inputTypes.includes(item.type)">
      <div class="flex-1">
        {{ item.title }}
      </div>
      <div class="flex items-end">
        <vs-input class="w-100 mt-1 flex-1" v-model="item.value" />
        <loading-button
          @confirm="save"
          :title="
            item.key === 'operator'
              ? 'ذخیره تلفن'
              : item.key === 'minimum-value'
              ? 'ذخیره مبلغ'
              : 'ذخیره'
          "
          :loading="loading"
          :hasProgress="false"
          className="w-fit"
          containerClassName="setting-save-button"
        />
      </div>
      <span class="text-xs">{{ item.description }}</span>
    </div>
    <div
      v-else-if="checkboxTypes.includes(item.type)"
      class="flex items-center"
    >
      <vs-checkbox v-model="item.value">
        <div class="flex flex-col">
          <span>{{ item.title }}</span>
          <span class="text-xs">{{ item.description }}</span>
        </div>
      </vs-checkbox>
      <Loader v-if="loading" color="#232323" size="7px" class="ml-2" />
      <feather-icon
        v-if="updated"
        icon="CheckIcon"
        class="w-5 h-5"
        style="color: green"
      />
    </div>
  </vs-col>
</template>

<script>
  import { mapGetters } from "vuex";
  import productApiService from "../../services/api/ProductApiService";
  import Loader from "../../components/Loader.vue";
  import LoadingButton from "../../components/loading-button/LoadingButton.vue";

  export default {
    name: "SettingItem",
    components: { Loader, LoadingButton },
    data() {
      return {
        loading: false,
        updated: false,
        inputTypes: ["integer", "string"],
        checkboxTypes: ["boolean"],
      };
    },
    computed: {
      ...mapGetters({
        currentProvider: "profile/currentProvider",
      }),
    },
    methods: {
      save(value) {
        this.loading = true;
        this.updated = false;
        productApiService
          .storeOrEditShopSettings(
            this.item.id,
            value ?? this.item.value,
            this.currentProvider.id
          )
          .then((result) => {
            this.$vs.notify({
              text: result.message,
              color: "success",
              position: "bottom-center",
            });
          })
          .finally(() => {
            this.loading = false;
            this.updated = true;
          });
      },
    },
    watch: {
      "item.value"(newValue) {
        if (typeof newValue === "boolean") {
          this.save(newValue);
        }
      },
    },
    props: {
      item: {
        type: Object,
        required: true,
      },
    },
  };
</script>

<style scoped lang="scss">
  // narrower than the shared loading button, the field next to it needs the
  // room, but never so narrow that the label wraps onto a second line
  .container.setting-save-button {
    min-width: 9rem;
    max-width: 12rem;
    white-space: nowrap;

    @media (max-width: 480px) {
      min-width: 8rem;
      max-width: 9rem;
    }
  }
</style>
